module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-26-f517c039e97d7381e00d773c8783b0dd.png";